import React, { useState } from "react";
import "../css/ModalCategorias.css";
import { toast } from 'react-toastify';
import '../css/Toast.css';

const ModalCategorias = ({ isOpen, onClose, onAddCategory }) => {
  const [newCategory, setNewCategory] = useState("");
  const [categoryDescription, setCategoryDescription] = useState("");

  const handleAdd = () => {
    if (newCategory && categoryDescription) {
      const newCategoryData = {
        nome: newCategory,
        descricao: categoryDescription,
      };
      onAddCategory(newCategoryData); // Passa o objeto completo para a função pai
      setNewCategory("");
      setCategoryDescription("");
      onClose();
    } else {
      toast.info("A categoria e a descrição não podem estar vazias.", {
        position: "top-right",
        autoClose: 3000,
        className: 'custom-toast'
      });
    }
  };

  return (
    isOpen && (
      <div className="modal-overlay show" onClick={onClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <button className="close-button" onClick={onClose}>
            X
          </button>
          <h3>Adicionar Nova Categoria</h3>
          <div className="form-group">
            <label>Nome da Categoria</label>
            <input
              type="text"
              placeholder="Digite uma nova categoria"
              value={newCategory}
              onChange={(e) => setNewCategory(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Descrição</label>
            <input
              type="text"
              placeholder="Digite a descrição da categoria"
              value={categoryDescription}
              onChange={(e) => setCategoryDescription(e.target.value)}
            />
          </div>
          <button className="modal-close-add" onClick={handleAdd}>
            Adicionar
          </button>
        </div>
      </div>
    )
  );
};

export default ModalCategorias;
